// Utils
import makeSelectOptionsSelector from 'fc-utils/makeSelectOptionsSelector'

// Constants
import {
  PROP_LABEL,
} from 'fc-model-seasons'

// Selectors
import { sortedSeasons$ } from 'fc-seasons'

// Exports
export default makeSelectOptionsSelector(PROP_LABEL)(sortedSeasons$)
